import { useEffect, useState } from "react";
import { House, Clock, CheckCircle, Flag, CurrencyInr, Percent, Wallet } from "@phosphor-icons/react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { ownerNav } from "@/config/nav";
import api, { formatINR } from "@/lib/api";
import { StatSkeleton } from "@/components/Loaders";

const cards = [
  { key: "total_properties", label: "Total Properties", icon: House, money: false },
  { key: "pending_bookings", label: "Pending Bookings", icon: Clock, money: false },
  { key: "confirmed_bookings", label: "Confirmed Bookings", icon: CheckCircle, money: false },
  { key: "completed_bookings", label: "Completed Bookings", icon: Flag, money: false },
  { key: "total_booking_value", label: "Total Booking Value", icon: CurrencyInr, money: true },
  { key: "estimated_commission", label: "Estimated Commission", icon: Percent, money: true },
  { key: "estimated_earnings", label: "Estimated Earnings", icon: Wallet, money: true },
];

export default function OwnerDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/owner/dashboard").then((r) => setData(r.data)); }, []);

  return (
    <DashboardLayout nav={ownerNav} title="Owner">
      <h1 className="font-heading text-2xl font-semibold text-stone-900 md:text-3xl">Dashboard</h1>
      <p className="mt-1 text-sm text-stone-500">Overview of your properties and bookings.</p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {!data
          ? [1, 2, 3, 4].map((i) => <StatSkeleton key={i} />)
          : cards.map((c) => {
              const Icon = c.icon;
              return (
                <div key={c.key} data-testid={`stat-${c.key}`} className="rounded-2xl border border-stone-200 bg-white p-6">
                  <div className="flex items-center justify-between">
                    <p className="text-xs uppercase tracking-wide text-stone-400">{c.label}</p>
                    <Icon size={20} weight="duotone" className="text-primary" />
                  </div>
                  <p className="mt-3 font-heading text-2xl font-bold text-stone-900 tabular-nums">
                    {c.money ? formatINR(data[c.key]) : data[c.key]}
                  </p>
                </div>
              );
            })}
      </div>
    </DashboardLayout>
  );
}
